import {
  FETCH_MASTER_CONTRACTS_REQUEST,
  FETCH_MASTER_CONTRACTS_SUCCESS,
  FETCH_MASTER_CONTRACTS_FAILURE,
} from '../../constants/ActionTypes';

const masterContracts = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_MASTER_CONTRACTS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_MASTER_CONTRACTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_MASTER_CONTRACTS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

export default masterContracts;
